import './App.css';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { age } from './scripts/age';
import { language } from './scripts/language';
import { category } from './scripts/category';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faItunes, faFacebook, faLinkedin, faXTwitter, faSquareReddit } from '@fortawesome/free-brands-svg-icons';
import { faArrowUpFromBracket, faPlay, faHeart, faArrowRightFromBracket, faArrowUp, faShuffle } from '@fortawesome/free-solid-svg-icons';
//import SpotifyArtistImage from './scripts/SpotifyArtistImage';
import SpotifySongs from './scripts/SpotifySongs';
import MyLikedSongs from "./scripts/MyLikedSongs";
import AdSense from './scripts/AdSense';
import Cookies from 'js-cookie';
import TypingEffect from "react-typing-effect";
import { news } from './scripts/data.js';
//import { AppContext } from './context/AppContext'
import { useGoogleLogin } from '@react-oauth/google';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error('Render error caught by boundary:', error);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="text-center p-8">
                    <p className="text-white text-lg mb-4">Something went wrong loading results.</p>
                    <button className="Query_Button" onClick={() => this.setState({ hasError: false })}>
                        Try Again
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    const [ selectedAge, setSelectedAge ] = useState(age[1]);
    const [ selectedLan, setSelectedLan ] = useState(language[2]);
    const [ selectedCat, setSelectedCat ] = useState(category[0]);
    const [ catDisabled, setCatDisabled ] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);
    const [ searchBtnText, setSearchBtnText ] = useState('show me now');
    const [ singers, setSingers ] = useState([]);
    const [ randomSingers, setRandomSingers ] = useState([]);
    const [ clickHistory, setClickHistory ] = useState({ history: [] });
    const [ artistMode, setArtistMode ] = useState(false);
    const [ likedSongsMode, setLikedSongsMode ] = useState(false);
    const [ artistFilter, setArtistFilter] = useState('');
    const [ defaultPlatform, setDefaultPlatform ] = useState('iTunes');
    const buttonRef = useRef(null);
    const [ spotifyIds, setSpotifyIds ] = useState([]);
    const [ spotifyJsons, setSpotifyJsons ] = useState([]);
    const artistPerPage = 5;
    const artistModeSongs = 20;
    const [ user, setUser ] = useState(null);
    const [ accessToken, setAccessToken ] = useState(null);
    const [ isMenuOpen, setIsMenuOpen ] = useState(false);
    const [ likesShownNum, setLikesShownNum ] = useState(10);
    const [ myLikes, setMyLikes ] = useState([]);
    const menuRef = useRef(null);
    const shownArtistNamesRef = useRef([]);
    const surpriseModeRef = useRef(false);

    const apiKey = process.env.REACT_APP_YTSEARCH_KEY;

    const newsContent = news.filter(active =>
        active.active === true
    );
    const newsArray = newsContent.map(active =>
        active.content
    );

    const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

    const handleLoginSuccess = (response) => {
        const token = response.access_token;
        setAccessToken(token);
        // Make a request to the Google API to get the user's profile
        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            })
            .then((res) => res.json())
            .then((data) => {
                const userEmail = data.email;
                const picture = data.picture;
                const name = data.name;
                const userInfo = {
                    email: userEmail,
                    picture: picture,
                    name: name,
                };
                setUser(userInfo);
                // Save user info to localStorage
                localStorage.setItem('user', JSON.stringify(userInfo));
            })
            .catch((error) => {
                console.error('Error fetching user data:', error);
            });
    };

    const handleLoginFailure = () => {
        console.log('Login Failed');
    };

    const login = useGoogleLogin({
        clientId: clientId,
        scope: 'email profile',
        prompt: 'consent',
        onSuccess: handleLoginSuccess,
        onError: handleLoginFailure,
    });

    const logout = () => {
        setUser(null);
        localStorage.removeItem('user');
        setIsMenuOpen(false);
        if (likedSongsMode) likedSongsModelRemove();
        // Optional: Revoke token
        if (accessToken) {
            fetch(`https://accounts.google.com/o/oauth2/revoke?token=${accessToken}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                },
            })
                .then(() => {
                    //console.log('Token revoked successfully');
                })
                .catch((error) => {
                    console.error('Error revoking token:', error);
                });
        }
    };

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
            setUser(JSON.parse(savedUser));
        }

        const lanIdCookie = Cookies.get('lanIdCookie');
        if (lanIdCookie) setSelectedLan(language[lanIdCookie]);

        const ageIdCookie = Cookies.get('ageIdCookie');
        if (ageIdCookie) setSelectedAge(age[ageIdCookie]);
        if (lanIdCookie !== '2') {
            setSelectedCat(category[0]);
            setCatDisabled(true);
        } else {
            //setCatDisabled(false);
            const catIdCookie = Cookies.get('catIdCookie');
            if (catIdCookie) setSelectedCat(category[catIdCookie]);
        }

        const historyCookie = Cookies.get('historyCookie');
        if (historyCookie) setClickHistory(JSON.parse(historyCookie));

        const defaultPlatformCookie = Cookies.get("defaultPlatform");
        if (defaultPlatformCookie === 'iTunes' || defaultPlatformCookie === 'YouTube') setDefaultPlatform(defaultPlatformCookie);

        setTimeout(triggerClick, 100);

        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && event.target.className!=='Profile_Icon') {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
              document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Ref always holds the latest implementation so handleIdsCollected
    // can be a stable useCallback([], []) — prevents SpotifySongs from
    // re-firing its songs useEffect on every parent re-render.
    const handleIdsCollectedRef = useRef(null);
    handleIdsCollectedRef.current = (ids, spotify_track) => {
        if (!spotifyIds.includes(ids)) {
            spotifyIds.push(ids);
            spotifyJsons.push(spotify_track);
            checkLikeCount().then(r => {});
            checkClickCount().then(r => {});
        }
    };
    const handleIdsCollected = useCallback((ids, spotify_track) => {
        handleIdsCollectedRef.current?.(ids, spotify_track);
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    async function checkLikeCount() {
        let loaded = false;
        if ((artistMode && spotifyIds.length === artistModeSongs) || (likedSongsMode && spotifyIds.length === likesShownNum) || (!artistMode && !likedSongsMode && spotifyIds.length === artistPerPage)) loaded = true;
        if (loaded) {
            const results = await likeCountAPI(spotifyIds);
            for (const result of results) {
                const songLikeCount = document.getElementById(result._id);
                if (songLikeCount) songLikeCount.innerText = result.count;
            }
            if (isMenuOpen) setIsMenuOpen(false);
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    async function checkClickCount() {
        let loaded = false;
        if ((artistMode && spotifyIds.length === artistModeSongs) || (likedSongsMode && spotifyIds.length === likesShownNum) || (!artistMode && !likedSongsMode && spotifyIds.length === artistPerPage)) loaded = true;
        if (loaded) {
            const results = await clickCountAPI(spotifyIds);
            for (const result of results) {
                const songClickCount = document.getElementById(`c_${result._id}`);
                if (songClickCount) songClickCount.innerText = result.count;
            }
        }
    }

    const likeCountAPI = async (spotify_ids) => {
        const jsonToQuery = {
            spotify_ids: spotify_ids,
            key: apiKey,
        };

        try {
            const response = await axios.post('https://ytsearch.kenylin.com/api/mdb/likecountbybatch', jsonToQuery);
            return response.data.counts;
        } catch (err) {
            console.log(err.message);
        }
    };

    const clickCountAPI = async (spotify_ids) => {
        const jsonToQuery = {
            spotify_ids: spotify_ids,
            key: apiKey,
        };

        try {
            const response = await axios.post('https://ytsearch.kenylin.com/api/mdb/clickcountbybatch', jsonToQuery);
            return response.data.counts;
        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        setSingers([]);
        setRandomSingers([]);
        shownArtistNamesRef.current = [];
        //if (artistMode) artistModelRemove();
        Cookies.set('lanIdCookie', selectedLan.id, { expires: 365 });
        if (selectedLan.id !== 2) {
            setSelectedCat(category[0]);
            setCatDisabled(true);
        } else {
            setCatDisabled(false);
        }
        setSearchBtnText('show me now');
    }, [selectedLan]);

    useEffect(() => {
        setSingers([]);
        setRandomSingers([]);
        shownArtistNamesRef.current = [];
        //if (artistMode) artistModelRemove();
        Cookies.set('ageIdCookie', selectedAge.id, { expires: 365 });
        setSearchBtnText('show me now');
    }, [selectedAge]);

    useEffect(() => {
        setSingers([]);
        setRandomSingers([]);
        shownArtistNamesRef.current = [];
        //if (artistMode) artistModelRemove();
        Cookies.set('catIdCookie', selectedCat.id, { expires: 365 });
        setSearchBtnText('show me now');
    }, [selectedCat]);

    useEffect(() => {
        Cookies.set('historyCookie', JSON.stringify(clickHistory), { expires: 365 });
    }, [clickHistory]);

    useEffect(() => {
        Cookies.set('defaultPlatform', defaultPlatform, { expires: 365 });
    }, [defaultPlatform]);

    const anthropicApiKey = process.env.REACT_APP_ANTHROPIC_API_KEY;

    const queryAI = async (event) => {
        event.preventDefault();
        if (artistMode || likedSongsMode) return;
        setIsProcessing(true);
        setSpotifyIds([]);
        setSpotifyJsons([]);
        setSearchBtnText(surpriseModeRef.current ? 'finding something new...' : 'loading data...');

        const currentlyShown = randomSingers.map(s => (s.artistName || '').toLowerCase().trim()).filter(Boolean);
        if (currentlyShown.length > 0) {
            shownArtistNamesRef.current = [...new Set([...shownArtistNamesRef.current, ...currentlyShown])];
        }

        if (singers.length === 0) {
            let newRandomAge = Math.floor(Math.random() * 10) + selectedAge.age;
            const currentYear = parseInt(new Date().getFullYear(), 10);
            const birthYear = currentYear - newRandomAge;
            const formativeStart = Math.max(1965, birthYear + 14);
            const formativeEnd = Math.min(currentYear, birthYear + 26);

            const nativeNameInstruction = selectedLan.code === 'en'
                ? 'use the same artist name in both artistName and artistNativeName'
                : `show the English name in artistName and the ${selectedLan.englishName} native-script name in artistNativeName`;
            const catFilter = selectedCat.name === 'All' ? '' : ` ${selectedCat.name}`;

            let eraClause;
            if (formativeStart >= currentYear - 5) {
                eraClause = `who are currently popular`;
            } else if (formativeEnd >= currentYear - 2) {
                eraClause = `who became popular between ${formativeStart} and today`;
            } else {
                eraClause = `who were most popular between ${formativeStart} and ${formativeEnd}`;
            }

            let msgSinger = `Please provide me with 50 ${selectedLan.englishName}-language${catFilter} artists ${eraClause}. Please ${nativeNameInstruction}.`;

            const isSurprise = surpriseModeRef.current;
            surpriseModeRef.current = false;

            let engagedArtistsList = [];
            if (isSurprise) {
                let knownGenres = [];
                let knownDecades = [];
                if (user) {
                    try {
                        const tasteRes = await axios.post('https://ytsearch.kenylin.com/api/mdb/tasteprofile', {
                            key: apiKey, user: user.email,
                            language: selectedLan.englishName, age: selectedAge.name,
                        });
                        knownGenres = tasteRes.data.genres || [];
                        knownDecades = tasteRes.data.decades || [];
                    } catch (_) {}
                }
                const avoidParts = [
                    knownGenres.length > 0 && `genres (${knownGenres.join(', ')})`,
                    knownDecades.length > 0 && `decades (${knownDecades.join(', ')})`,
                ].filter(Boolean);
                msgSinger = `The user wants to discover something new. ${avoidParts.length > 0 ? `They already know ${avoidParts.join(' and ')} — avoid those and recommend contrasting or complementary styles instead.` : 'Surprise them with artists they are unlikely to have heard before.'} ` + msgSinger;
            } else {
                let engagementContext = '';
                if (user) {
                    try {
                        const [engagedRes, tasteRes] = await Promise.all([
                            axios.post('https://ytsearch.kenylin.com/api/mdb/topengagedartists', {
                                key: apiKey, user: user.email,
                                language: selectedLan.englishName, age: selectedAge.name,
                            }),
                            axios.post('https://ytsearch.kenylin.com/api/mdb/tasteprofile', {
                                key: apiKey, user: user.email,
                                language: selectedLan.englishName, age: selectedAge.name,
                            }),
                        ]);
                        const topArtists = engagedRes.data.artists || [];
                        const genres = tasteRes.data.genres || [];
                        const decades = tasteRes.data.decades || [];

                        if (topArtists.length > 0) {
                            engagedArtistsList = topArtists.map(a => a.artist_name);
                            engagementContext += `This user has previously engaged with these artists (higher score = stronger preference): ${topArtists.map(a => `${a.artist_name}(${a.score})`).join(', ')}.`;
                        }
                        if (genres.length > 0) {
                            engagementContext += ` Their preferred genres are: ${genres.join(', ')}.`;
                        }
                        if (decades.length > 0) {
                            engagementContext += ` They gravitate toward music from the ${decades.join(', ')}.`;
                        }
                    } catch (_) {}
                }

                if (engagementContext) {
                    msgSinger = `${engagementContext} Recommend artists with a SIMILAR style and vibe. ` + msgSinger;
                } else {
                    const history = clickHistory.history.filter(entry =>
                        entry.language === selectedLan.name &&
                        entry.age === selectedAge.name
                    );
                    if (history.length > 0) {
                        const recentHistory = history.slice(-15);
                        const uniqueArtists = [...new Set(recentHistory.map(item => item.artist))].slice(-8);
                        msgSinger = `The user already knows and enjoys: ${uniqueArtists.join(', ')}. Recommend artists with a SIMILAR style but do NOT include any of these artists. ` + msgSinger;
                    }
                }
            }

            const skipList = [...new Set([...shownArtistNamesRef.current, ...engagedArtistsList])];
            const systemPrompt = `You are a music discovery expert. The user is ${newRandomAge} years old — their musical taste was shaped by the ${formativeStart}–${formativeEnd} era.

Respond ONLY with a valid JSON array — no markdown, no explanation.
Format: [{"id":1,"artistName":"English Name","artistNativeName":"Native Name"}, ...]

Rules:
- Prioritize artists whose peak popularity aligns with the user's formative years (${formativeStart}–${formativeEnd})
- Include a mix of well-known AND lesser-known/underground artists for variety
- Only include artists whose music is available on iTunes/Apple Music
- All artists must genuinely perform in the requested language
- Avoid the most obvious top-5 mainstream names — go deeper into the catalog${isSurprise ? '\n- This is a "Surprise Me" request — actively explore different genres and eras the user has not experienced before' : ''}${skipList.length > 0 ? `\n- Do NOT include any of these artists (already known/shown to this user): ${skipList.join(', ')}` : ''}`;
            const userMessages = [
                { role: 'user', content: 'I am ' + newRandomAge + ' years old.' },
                { role: 'assistant', content: 'Understood.' },
                { role: 'user', content: 'I always listen to songs in ' + selectedLan.name + '.' },
                { role: 'assistant', content: 'Got it.' },
                { role: 'user', content: msgSinger },
            ];

            const maxRetries = 3;
            let success = false;
            for (let attempt = 0; attempt <= maxRetries; attempt++) {
                try {
                    const response = await fetch('https://api.anthropic.com/v1/messages', {
                        method: 'POST',
                        headers: {
                            'x-api-key': anthropicApiKey,
                            'anthropic-version': '2023-06-01',
                            'anthropic-dangerous-direct-browser-access': 'true',
                            'content-type': 'application/json',
                        },
                        body: JSON.stringify({
                            model: 'claude-haiku-4-5-20251001',
                            max_tokens: 4096,
                            temperature: 1,
                            system: systemPrompt,
                            messages: userMessages,
                        }),
                    });
                    if (!response.ok) {
                        const err = await response.json().catch(() => ({}));
                        const error = new Error(err?.error?.message || response.statusText);
                        error.status = response.status;
                        throw error;
                    }
                    const result = await response.json();
                    const rawText = result.content[0].text;
                    const match = rawText.match(/\[[\s\S]*\]/);
                    const jsonDataSinger = match ? match[0] : rawText;
                    let jsonObjectSinger = JSON.parse(jsonDataSinger);
                    if (!Array.isArray(jsonObjectSinger)) throw new Error('Response is not an array');
                    jsonObjectSinger = jsonObjectSinger.filter(
                        a => a && typeof a.artistName === 'string' && a.artistName.trim()
                          && typeof a.artistNativeName === 'string' && a.artistNativeName.trim()
                    );
                    if (jsonObjectSinger.length < 5) throw new Error('Too few valid artists in response');
                    const seen = new Set();
                    jsonObjectSinger = jsonObjectSinger.filter(a => {
                        const key = a.artistName.toLowerCase().trim();
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    });
                    setSingers(jsonObjectSinger);
                    const shuffledData = shuffleArray(jsonObjectSinger);
                    setRandomSingers(shuffledData.slice(0, artistPerPage));
                    success = true;
                    break;
                } catch (error) {
                    console.error(`Claude attempt ${attempt + 1} failed:`, error);
                    const isRetryable = error?.status === 429 || error?.status === 529;
                    if (isRetryable && attempt < maxRetries) {
                        const delay = Math.pow(2, attempt + 1) * 1000;
                        setSearchBtnText(`retrying...`);
                        await new Promise(resolve => setTimeout(resolve, delay));
                        setSearchBtnText('loading data...');
                    } else {
                        setSearchBtnText('try again');
                        setIsProcessing(false);
                        return;
                    }
                }
            }
            if (!success) {
                setSearchBtnText('try again');
                setIsProcessing(false);
                return;
            }
        } else {
            const removeIds = [];
            // eslint-disable-next-line array-callback-return
            randomSingers.map( item => {
                removeIds.push(item.id);
            })
            const updatedData = singers.filter(record => !removeIds.includes(record.id));
            setSingers(updatedData);
            if (updatedData.length === 0) {
                setRandomSingers([]);
                setTimeout(triggerClick, 100);
                setIsProcessing(false);
                return;
            } else {
                const shuffledData = shuffleArray(updatedData);
                setRandomSingers(shuffledData.slice(0, artistPerPage));
                //console.log(randomSingers);
            }
        }
        setSearchBtnText('next round');
        setIsProcessing(false);
    };

    const shuffleArray = (array) => {
        const shuffledArray = [...array]; // Create a copy to avoid mutating the original array

        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
        }

        return shuffledArray;
    };

    const triggerClick = () => {
        if (buttonRef.current) {
            buttonRef.current.click(); // Programmatically click the button again
        }
    };

    const handleSurpriseClick = () => {
        if (isProcessing || artistMode || likedSongsMode) return;
        surpriseModeRef.current = true;
        shownArtistNamesRef.current = [];
        setSingers([]);
        setRandomSingers([]);
        setTimeout(triggerClick, 100);
    };

    const songClick = (event) => {
          //event.preventDefault();
          let artistClick = '';
          let songClick = '';
          let spotifyIdClick= '';

          if (event.target.tagName === 'A') {
              artistClick = event.target.getAttribute('artist');
              songClick = event.target.getAttribute('song');
              spotifyIdClick = event.target.getAttribute('spotify');
              if (event.target.href.slice(-1) === '#') {
                  artistNameClick(artistClick, event.target.getAttribute('artistengname'));
                  return;
              }
          } else if ((event.target.tagName === 'svg' && event.target.parentElement.tagName === 'P') || (event.target.tagName === 'path' && event.target.parentElement.parentElement.tagName === 'P')) {
              let likeObj = event.target.tagName === 'svg' ? event.target : event.target.parentElement;

              if (likeObj.getAttribute('clicked') === 'true') return;
              artistClick = likeObj.getAttribute('artist');
              songClick = likeObj.getAttribute('song');
              spotifyIdClick = likeObj.getAttribute('spotify');

              likeObj.setAttribute('clicked', 'true');
              callLikeAPI(artistClick, songClick, spotifyIdClick).then(r => {});
              if (!likedSongsMode) addHistoryData(artistClick, songClick);
              return;
          } else if (event.target.tagName === 'svg' && event.target.parentElement.tagName === 'A') {
              artistClick = event.target.parentElement.getAttribute('artist');
              songClick = event.target.parentElement.getAttribute('song');
              spotifyIdClick = event.target.parentElement.getAttribute('spotify');
          } else if (event.target.tagName === 'path' && event.target.parentElement.parentElement.tagName === 'A') {
              artistClick = event.target.parentElement.parentElement.getAttribute('artist');
              songClick = event.target.parentElement.parentElement.getAttribute('song');
              spotifyIdClick = event.target.parentElement.parentElement.getAttribute('spotify');
          } else if (event.target.tagName === 'IMG') {
              artistClick = event.target.parentElement.getAttribute('artist');
              songClick = event.target.parentElement.getAttribute('song');
              spotifyIdClick = event.target.parentElement.getAttribute('spotify');
          } else {
              return;
          }

          if (!likedSongsMode) addHistoryData(artistClick, songClick);
          let clickCount = document.getElementById(`c_${spotifyIdClick}`);
          clickCount.innerText = (parseInt(clickCount.innerText, 10) + 1).toString();
          callClickAPI(artistClick, songClick, spotifyIdClick).then(r => {});
    };

    const callLikeAPI = async (artist, song, spotify) => {
        const sJson = spotifyJsons.find((item) => String(item.trackId) === spotify || item.id === spotify);

        const jsonToSave = {
            artist_name: artist,
            song_name: song,
            language: selectedLan.englishName,
            spotify_id: spotify,
            age: selectedAge.name,
            user: !user? 'guest' : user.email,
            spotify_json: sJson,
            key: apiKey,
        };

        try {
            const response = await axios.post('https://ytsearch.kenylin.com/api/mdb/likesong', jsonToSave);
            if (response.status === 201) {
                let likeCount = document.getElementById(spotify);
                likeCount.innerText = (parseInt(likeCount.innerText, 10) + 1).toString();
            }
        } catch (error) {
            if (error.response.status === 409) {
                console.log('Record existed')
            }else {
                console.error('Error saving record:', error);
            }
        }
    };

    const callClickAPI = async (artist, song, spotify) => {
        const sJson = spotifyJsons.find((item) => String(item.trackId) === spotify || item.id === spotify);

        const jsonToSave = {
            artist_name: artist,
            song_name: song,
            language: selectedLan.englishName,
            spotify_id: spotify,
            age: selectedAge.name,
            user: !user? 'guest' : user.email,
            spotify_json: sJson,
            key: apiKey,
        };

        try {
            await axios.post('https://ytsearch.kenylin.com/api/mdb/clicksong', jsonToSave);
        } catch (error) {
            console.error('Error saving record:', error);
        }
    };

    const addHistoryData = (artist, song) => {
        const newEntry = {
            artist: artist,
            song: song,
            age: selectedAge.name,
            language: selectedLan.name,
            category: selectedCat.name,
        };

        if (clickHistory.history.length > 15) {
            setClickHistory((prevData) => ({
                ...prevData,
                history: prevData.history.slice(-14),
            }));
        }

        setClickHistory((prevData) => ({
            ...prevData,
            history: [...prevData.history, newEntry],
        }));
    };

    function artistNameClick(artistName, artistEngName) {
        if (artistMode || isProcessing) return;

        if (likedSongsMode) {
            setLikedSongsMode(false);
            setMyLikes([]);
        }

        setArtistMode(true);
        setArtistFilter(artistName);
        setRandomSingers([]);
        setSpotifyIds([]);
        setSpotifyJsons([]);
        setSearchBtnText('artist mode');

        const artistItem = [{
            id: 1,
            artistName: artistEngName,
            artistNativeName: artistName
        }];

        setRandomSingers(artistItem);
    }

    function artistModelRemove() {
        setArtistMode(false);
        setArtistFilter('');
        setSearchBtnText('show me now');
        setRandomSingers([]);
        setTimeout(triggerClick, 100);
    }

    const showMylikes = async () => {
        if (!user || isProcessing) return;

        const jsonToQuery = {
            user: user.email,
            key: apiKey,
        };

        try {
            const response = await axios.post('https://ytsearch.kenylin.com/api/mdb/likesbyuser', jsonToQuery);
            const likes = response.data.likes;

            setRandomSingers([]);
            setSpotifyIds([]);
            setSpotifyJsons([]);
            setIsMenuOpen(false);
            setLikedSongsMode(true);
            if (artistMode) {
                setArtistMode(false);
                setArtistFilter('');
            }
            setSearchBtnText('my likes mode:');
            setLikesShownNum(10);

            setMyLikes(likes.filter(like => !!like.spotify_json));
            //console.log(likes);
        } catch (err) {
            console.log(err.message);
        }
    };

    function moreLikesNum () {
        setLikesShownNum(likesShownNum + 10);
    }

    function likedSongsModelRemove() {
        setLikedSongsMode(false);
        setMyLikes([]);
        setSearchBtnText('show me now');
        setTimeout(triggerClick, 100);
    }

    const url = 'https://song.kenylin.com';
    const text = 'Check out this amazing website!';

    const socialLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
        reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`,
    };

    const defaultPlatformChange = (value) => {
       setDefaultPlatform(value);
    };

    const handleCopyUrl = () => {
        // Copy to clipboard
        navigator.clipboard
          .writeText('https://song.kenylin.com')
          .then(() => {
            alert('URL copied to clipboard. You can share to others. Thank you!');
          })
          .catch((err) => {
            console.error('Failed to copy the URL: ', err);
          });
    };

    const handleScrollToTop = () => {
        document.getElementById('header').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    };
    return (
        <div className="App">
            <div className="Content">
                {/* Dropdown Menu */}
                {isMenuOpen && (
                <div ref={menuRef}
                    className={`absolute top-7 text-left right-0 bg-gray-800 mt-2 w-36 rounded-lg shadow-lg border border-gray-400 transition-transform duration-200
                    ${isMenuOpen ? "scale-100 opacity-100" : "scale-95 opacity-0 pointer-events-none"}`}>
                    <ul className="py-1">
                        <li className="px-4 py-1 font-bold hover:bg-gray-600 cursor-pointer" onClick={() => showMylikes()}>
                            <div className="flex grid-cols-2 gap-4 content-start">
                                <div className="shrink-0 flex-col text-left">
                                    <FontAwesomeIcon icon={faHeart}/>
                                </div>
                                <div>
                                    my likes
                                </div>
                            </div>
                        </li>
                        <li className="px-4 py-1 font-bold hover:bg-gray-600 cursor-pointer" onClick={() => logout()}>
                            <div className="flex grid-cols-2 gap-4 content-start">
                                <div className="shrink-0 flex-col text-left">
                                    <FontAwesomeIcon icon={faArrowRightFromBracket}/>
                                </div>
                                <div>
                                    logout
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                    )}
                {/* Dropdown Menu End */}
                <div className="Header" id='header'>
                    <div>
                        <div>song for you</div>
                        <div className="text-sm italic text-gray-400 -mt-0.5">
                            let <span className="text-blue-400 font-extrabold animate-pulse">AI</span> find songs for you
                        </div>
                    </div>
                    <div className="flex items-center gap-3 text-base">
                        <FontAwesomeIcon onClick={handleCopyUrl} className="cursor-pointer hover:text-gray-400" icon={faArrowUpFromBracket}/>
                        <div className="w-px h-4 bg-gray-600"/>
                        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon className="hover:text-[#1877F2]" icon={faFacebook}/>
                        </a>
                        <a href={socialLinks.reddit} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon className="hover:text-[#FF4500]" icon={faSquareReddit}/>
                        </a>
                        <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon className="hover:text-black hover:bg-white hover:rounded-full" icon={faXTwitter}/>
                        </a>
                        <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon className="hover:text-[#0A66C2]" icon={faLinkedin}/>
                        </a>
                        <div className="w-px h-4 bg-gray-600"/>
                        {!user ? (
                            <img onClick={() => login()} className="Profile_Icon"
                                 src="https://developers.google.com/identity/images/g-logo.png" alt="Google Logo" title="Sign in to Google"/>
                        ) : (
                            <img onClick={() => setIsMenuOpen((prev) => !prev)} className="Profile_Icon"
                                 src={user.picture} alt={user.name} title={user.name}/>
                        )}
                    </div>
                </div>
                <div className="Options">
                    <div className="mx-1">
                        <Listbox value={selectedAge} onChange={setSelectedAge}>
                            <Label className="Options_Label">your age</Label>
                            <div className="relative mt-2">
                                <ListboxButton className="Options_ListBoxButton">
                                    <span className="flex items-center">
                                        <span className="ml-1 block truncate text-sm">{selectedAge.name}</span>
                                    </span>
                                    <span
                                        className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                        <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400"/>
                                    </span>
                                </ListboxButton>

                                <ListboxOptions transition className="Options_ListBoxOptions">
                                    {age.map((range) => (
                                        <ListboxOption
                                            key={range.id}
                                            value={range}
                                            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                                        >
                                            <div className="flex items-center">
                                            <span
                                                className="ml-1 block truncate font-normal group-data-[selected]:font-semibold text-sm">
                                                {range.name}
                                            </span>
                                            </div>
                                            <span
                                                className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="h-5 w-5"/>
                                        </span>
                                        </ListboxOption>
                                    ))}
                                </ListboxOptions>
                            </div>
                        </Listbox>
                    </div>
                    <div className="mx-1">
                        <Listbox value={selectedLan} onChange={setSelectedLan}>
                            <Label className="Options_Label">song language</Label>
                            <div className="relative mt-2">
                                <ListboxButton className="Options_ListBoxButton">
                                    <span className="flex items-center">
                                        <span
                                            className="ml-1 block truncate text-sm">{selectedLan.name} - {selectedLan.englishName}</span>
                                    </span>
                                    <span
                                        className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                        <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400"/>
                                    </span>
                                </ListboxButton>

                                <ListboxOptions transition className="Options_ListBoxOptions">
                                    {language.map((lan) => (
                                        <ListboxOption
                                            key={lan.code}
                                            value={lan}
                                            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                                        >
                                            <div className="flex items-center">
                                            <span
                                                className="ml-1 block truncate font-normal group-data-[selected]:font-semibold text-sm">
                                                {lan.name} - {lan.englishName}
                                            </span>
                                            </div>
                                            <span
                                                className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="h-5 w-5"/>
                                        </span>
                                        </ListboxOption>
                                    ))}
                                </ListboxOptions>
                            </div>
                        </Listbox>
                    </div>
                    <div className="mx-1">
                        <span className="Options_Label">link</span>
                        <div className="flex mt-2 rounded-lg overflow-hidden border border-gray-600 w-fit">
                            {[{ label: 'Apple Music', value: 'iTunes', icon: faItunes }, { label: 'YouTube', value: 'YouTube', icon: faYoutube }].map(({ label, value, icon }) => (
                                <button
                                    key={value}
                                    onClick={() => defaultPlatformChange(value)}
                                    className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold transition-colors ${
                                        defaultPlatform === value ? 'bg-blue-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-700'
                                    }`}
                                >
                                    <FontAwesomeIcon icon={icon}/> {label}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="mx-1">
                        <Listbox value={selectedCat} onChange={setSelectedCat} disabled={catDisabled}>
                            <Label className="Options_Label">category</Label>
                            <div className="relative mt-2">
                                <ListboxButton
                                    className={`Options_ListBoxButton ${selectedLan.name === 'English' ? '' : 'disabled'}`}>
                                    <span className="flex items-center">
                                        <span
                                            className="ml-1 block truncate text-sm">{selectedCat.name}</span>
                                    </span>
                                    <span
                                        className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                                        <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400"/>
                                    </span>
                                </ListboxButton>

                                <ListboxOptions transition className="Options_ListBoxOptions">
                                    {category.map((cat) => (
                                        <ListboxOption
                                            key={cat.id}
                                            value={cat}
                                            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
                                        >
                                            <div className="flex items-center">
                                            <span
                                                className="ml-1 block truncate font-normal group-data-[selected]:font-semibold text-sm">
                                                {cat.name}
                                            </span>
                                            </div>
                                            <span
                                                className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                                            <CheckIcon aria-hidden="true" className="h-5 w-5"/>
                                        </span>
                                        </ListboxOption>
                                    ))}
                                </ListboxOptions>
                            </div>
                        </Listbox>
                    </div>
                    <div className="border-b border-gray-500 my-6 col-span-2"></div>
                    <div className="text-left mx-1 col-span-2 grid grid-cols-2 gap-1">
                        <div className="col-span-2 mb-6">
                            <div className={`text-base font-medium leading-6 ${artistMode && 'hidden'}`}>
                                <TypingEffect
                                    text={newsArray}
                                    speed={75}
                                    eraseSpeed={20}
                                    typingDelay={500}
                                    eraseDelay={3000}
                                />
                            </div>
                        </div>
                        <div>
                            <div className="flex gap-2 flex-wrap items-center">
                                <button ref={buttonRef} disabled={isProcessing} className={`Query_Button ${isProcessing}`}
                                        onClick={queryAI}>{searchBtnText}
                                </button>
                                <button
                                    disabled={isProcessing || artistMode || likedSongsMode}
                                    className={`Surprise_Button ${isProcessing || artistMode || likedSongsMode}`}
                                    onClick={handleSurpriseClick}>
                                    <FontAwesomeIcon icon={faShuffle}/> surprise me
                                </button>
                            </div>
                            <p className={`text-sm mt-2 ml-2 ${!likedSongsMode && 'hidden'}`}>
                                {'total ' + myLikes.length + ' songs'}
                            </p>
                        </div>
                        <div>
                            <button className={`Filter_Button ${artistMode}`} onClick={artistModelRemove}>
                                <span className="absolute top-0 left-1 text-xs font-bold m-1 text-gray-900">X</span>
                                &nbsp;&nbsp;{artistFilter}
                            </button>
                            <button className={`Filter_Button ${likedSongsMode}`} onClick={likedSongsModelRemove}>
                                <span className="absolute top-0 left-1 text-xs font-bold m-1 text-gray-900">X</span>
                                &nbsp;&nbsp;leave my likes mode
                            </button>
                        </div>
                    </div>
                </div>
                <div className="Result">
                    <FontAwesomeIcon icon={faYoutube} className="hidden"/>
                    <FontAwesomeIcon icon={faItunes} className="hidden"/>
                    <FontAwesomeIcon icon={faPlay} className="hidden"/>
                    <FontAwesomeIcon icon={faHeart} className="hidden"/>
                    <div className='mt-8 mb-2 text-lg font-bold'>
                        {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
                        <ul role="list" className="divide-y divide-gray-500">
                            <ErrorBoundary>
                            {randomSingers.map((singer, index) => (
                                <li key={singer.id} onClick={songClick}>
                                    {(artistMode && index === 0) &&
                                        <div className="border-b border-gray-500"><AdSense layout="-h3-21+3a-e+1y"
                                                                                           slot="6836761345"/>
                                        </div>}
                                    <SpotifySongs artistName={(singer.artistNativeName || '').trim()}
                                                  artistEngName={(singer.artistName || '').trim()}
                                                  songCatName="All"
                                                  defaultPlatform={defaultPlatform}
                                                  artistModeSongs={artistModeSongs}
                                                  artistMode={artistMode}
                                                  selectedLan={selectedLan}
                                                  onIdsCollected={handleIdsCollected}/>
                                    {(index === 4 || (artistMode && index === 0)) &&
                                        <div className={`border-b ${!artistMode && 'border-t'} border-gray-500`}><AdSense
                                            layout="-h3-21+3a-e+1y"
                                            slot="2299454801"/></div>}
                                </li>
                            ))}
                            </ErrorBoundary>
                            {myLikes.length > 0 ? (
                                myLikes.slice(0, likesShownNum).map((like, index) => (
                                <li key={like._id} onClick={songClick}>
                                    <MyLikedSongs defaultPlatform={defaultPlatform}
                                                  song={like}
                                                  index={index}
                                                  onIdsCollected={handleIdsCollected}/>
                                    {(index % 10 === 9) &&
                                        <div className="border-t border-gray-500"><AdSense layout="-h3-21+3a-e+1y"
                                                                                           slot="6836761345"/>
                                        </div>}
                                    {(((index + 1) === likesShownNum) && (index + 1) < myLikes.length) &&
                                        <div className='border-t border-gray-500 pt-3 text-center'>
                                            <button className='More_Likes' onClick={moreLikesNum}>
                                                load more likes
                                            </button>
                                        </div>}
                                    {((index + 1) === myLikes.length) &&
                                        <div className='border-t border-gray-500 pt-3 text-center'>
                                        </div>}
                                </li>
                            )))
                            :
                                (likedSongsMode && <p>you don't have any liked song</p>)
                            }
                        </ul>
                    </div>
                    <div
                        className={`text-left mx-1 mt-6 grid grid-cols-2 gap-1 ${randomSingers.length !== 0 || likedSongsMode ? '' : 'hidden'} `}>
                        <div>
                            <div className='flex'>
                                <div className='flex-auto'>
                                    <div className="flex gap-2 flex-wrap items-center">
                                        <button ref={buttonRef} disabled={isProcessing}
                                                className={`Query_Button ${isProcessing}`}
                                                onClick={queryAI}>{searchBtnText}
                                        </button>
                                        <button
                                            disabled={isProcessing || artistMode || likedSongsMode}
                                            className={`Surprise_Button ${isProcessing || artistMode || likedSongsMode}`}
                                            onClick={handleSurpriseClick}>
                                            <FontAwesomeIcon icon={faShuffle}/> surprise me
                                        </button>
                                    </div>
                                    <p className={`text-sm mt-2 ml-2 ${!likedSongsMode && 'hidden'}`}>
                                        {'total ' + myLikes.length + ' songs'}
                                    </p>
                                </div>
                                <div className='flex-auto relative hidden'>
                                    <div className='absolute bottom-0'>
                                    <FontAwesomeIcon icon={faArrowUp} className='cursor-pointer' onClick={handleScrollToTop} bounce size='2xl'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button className={`Filter_Button ${artistMode}`} onClick={artistModelRemove}>
                                <span className="absolute top-0 left-1 text-xs font-bold m-1 text-gray-900">X</span>
                                &nbsp;&nbsp;{artistFilter}
                            </button>
                            <button className={`Filter_Button ${likedSongsMode}`} onClick={likedSongsModelRemove}>
                                <span className="absolute top-0 left-1 text-xs font-bold m-1 text-gray-900">X</span>
                                &nbsp;&nbsp;leave my likes mode
                            </button>
                        </div>
                        <br/>&nbsp;
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
